import React from 'react';
import { connect } from 'react-redux';
import { ContentGroup } from 'ui';
import { hasGlobalFeature } from 'selectors';
import { routes } from 'constants/config';
import * as assignmentsSelectors from 'selectors/learn/assignments';
import * as contentsSelectors from 'selectors/learn/contents';
import { createCompoundId } from 'selectors/learn/helpers';
import ContentCard from '../../shared/LearnContentCard';
import ViewAllLink from './ViewAllLink';

const IncompleteAssignments = ({
  incompleteAssignments,
  hasAssignments,
  hasLibraryContents,
  hasFeatureChangeAssignmentsToResources,
}) => (
  <ContentGroup
    className="LearnContentGroup"
    title={
      hasFeatureChangeAssignmentsToResources
        ? t('resources.incomplete.title')
        : t('assignments.incomplete.title')
    }
    items={incompleteAssignments}
  >
    {hasAssignments && hasLibraryContents && (
      <ContentGroup.Action>
        <ViewAllLink
          to={
            hasFeatureChangeAssignmentsToResources
              ? routes.LEARN_RESOURCES
              : routes.LEARN_ASSIGNMENTS
          }
        >
          {hasFeatureChangeAssignmentsToResources
            ? t('resources.view_all')
            : t('assignments.view_all')}
        </ViewAllLink>
      </ContentGroup.Action>
    )}
    <ContentGroup.Items
      render={assignment => (
        <ContentCard key={createCompoundId(assignment)} {...assignment} />
      )}
    />
  </ContentGroup>
);

const mapStateToProps = state => ({
  incompleteAssignments:
    assignmentsSelectors.allAssignmentsByType(state).incomplete,
  hasAssignments: assignmentsSelectors.hasAssignments(state),
  hasLibraryContents: contentsSelectors.hasLibraryContents(state),
  hasFeatureChangeAssignmentsToResources: hasGlobalFeature(
    state,
    'change_assignments_to_resources',
  ),
});

export default connect(mapStateToProps)(IncompleteAssignments);
